export var SectionNotificationButtonType;
(function (SectionNotificationButtonType) {
    SectionNotificationButtonType["default"] = "default";
    SectionNotificationButtonType["text"] = "text";
})(SectionNotificationButtonType || (SectionNotificationButtonType = {}));
export var SectionNotificationType;
(function (SectionNotificationType) {
    SectionNotificationType["default"] = "default";
    SectionNotificationType["error"] = "error";
    SectionNotificationType["alert"] = "alert";
    SectionNotificationType["wired"] = "wired";
    SectionNotificationType["success"] = "success";
})(SectionNotificationType || (SectionNotificationType = {}));
export var SectionNotificationSize;
(function (SectionNotificationSize) {
    SectionNotificationSize["regular"] = "regular";
    SectionNotificationSize["compact"] = "compact";
})(SectionNotificationSize || (SectionNotificationSize = {}));
export var SectionNotificationDataHooks;
(function (SectionNotificationDataHooks) {
    SectionNotificationDataHooks["icon"] = "icon";
    SectionNotificationDataHooks["text"] = "text";
    SectionNotificationDataHooks["button"] = "button";
})(SectionNotificationDataHooks || (SectionNotificationDataHooks = {}));
//# sourceMappingURL=types.js.map